import Wishlist from "../../components/features/wishlist/Wishlist";

const WishlistPage = () => {
  return <Wishlist />;
};

export default WishlistPage;
